export enum IconNameType {
    Plus = 'plus',
    H = 'h',
    AlignLeft = 'align-left',
    ClosedCaptioning = 'closed-captioning',
    ChevronUp = 'chevron-up',
    ChevronDown = 'chevron-down',
    Trash = 'trash',
    Eye = 'eye',
    EyeSlash = 'eye-slash',
    Ellipsis = 'ellipsis',
    FolderOpen = 'folder-open',
    FolderClosed = 'folder-closed',
    House = 'house',
    Clock = 'clock',
    Pen = 'pen',
    CaretRight = 'caret-right',
    CaretDown = 'caret-down',
    CircleDot = 'circle-dot',
    EmptySet = 'empty-set',
    CaretUp = 'caret-up',
    CalendarDays = 'calendar-days',
    UserPlus = 'user-plus',
    User = 'user',
    Headphones = 'headphones',
    RectangleHistory = 'rectangle-history',
    Brain = 'brain',
    RectangleHistoryCirclePlus = 'rectangle-history-circle-plus',
    UserSecret = 'user-secret',
    Down = 'down',
    Gear = 'gear',
    CommentDot = 'comment-dot',
    ClockRotateLeft = 'clock-rotate-left',
    Clone = 'clone',
    CircleUp = 'circle-up',
    CircleDown = 'circle-down',
    Compress = 'compress',
    BarsFilter = 'bars-filter',
    Filter = 'filter',
    Lock = 'lock',
    Link = 'link',
    Video = 'video',
    BroomWide = 'broom-wide',
    ArrowUpShortWide = 'arrow-up-short-wide',
    ArrowDownShortWide = 'arrow-down-short-wide',
    FileImport = 'file-import',
    FileExport = 'file-export',
    ArrowRightToLine = 'arrow-right-to-line',
    Sort = 'sort',
    ArrowDown = 'arrow-down',
    ArrowUp = 'arrow-up',
    LayerGroup = 'layer-group',
    List = 'list',
    Ban = 'ban',
    Thumbtack = 'thumbtack',
    EarthAmericas = 'earth-americas',
    FloppyDisk = 'floppy-disk',
    Gears = 'gears',
    Copy = 'copy',
    Scissors = 'scissors',
    Table = 'table',
    TableCellsRows = 'table-cells-rows',
    LocationDot = 'location-dot',
    AlignJustify = 'align-justify',
    Calendar = 'calendar',
    Columns3 = 'columns-3',
    Anchor = 'anchor',
    SignalStream = 'signal-stream',
    ChevronRight = 'chevron-right',
    ChevronLeft = 'chevron-left',
    PizzaSlice = 'pizza-slice',
    EllipsisVertical = 'ellipsis-vertical',
    LeftToBracket = 'left-to-bracket',
    Upload = 'upload',
    ArrowDownToBracket = 'arrow-down-to-bracket',
    UpToBracket = 'up-to-bracket',
    PaperPlane = 'paper-plane',
    CirclePlus = 'circle-plus',
    PenLine = 'pen-line',
    ArrowUpArrowDown = 'arrow-up-arrow-down',
    RightToBracket = 'right-to-bracket',
    RotateLeft = 'rotate-left',
    RotateRight = 'rotate-right',
    MagnifyingGlassMinus = 'magnifying-glass-minus',
    MagnifyingGlassPlus = 'magnifying-glass-plus',
    Maximize = 'maximize',
    Minimize = 'minimize',
    Download = 'download',
    Database = 'database',
    CommentLines = 'comment-lines',
    CommentExclamation = 'comment-exclamation',
    CommentQuote = 'comment-quote',
    Microphone = 'microphone',
    Grid2 = 'grid-2',
    Bolt = 'bolt',
    Folder = 'folder',
    SquareCheck = 'square-check',
    Square = 'square',
    BarsSort = 'bars-sort',
    Sidebar = 'sidebar',
    SidebarFlip = 'sidebar-flip',
    Text = 'text',
    GripVertical = 'grip-vertical',
    SortNumericDown = 'arrow-down-1-9',
    ClipboardCheck = 'clipboard-check',
    Feather = 'feather',
    UserVneck = 'user-vneck',
    UserVneckHair = 'user-vneck-hair',
    FaceGrin = 'face-grin',
    UserAlien = 'user-alien',
    FaceRollingEyes = 'face-rolling-eyes',
    Alien = 'alien',
    Star = 'star',
    CommentMiddle = 'comment-middle',
    File = 'file',
    Tags = 'tags',
    Phone = 'phone',
    PhoneVolume = 'phone-volume',
    At = 'at',
    MapMarkerAlt = 'location-pin',
    ArrowUpRightFromSquare = 'arrow-up-right-from-square',
    ArrowUpRight = 'arrow-up-right',
    ArrowDownRight = 'arrow-down-right',
    ArrowDownLeft = 'arrow-down-left',
    LinkSimple = 'link-simple',
    WandMagicSparkles = 'wand-magic-sparkles',
    Calculator = 'calculator',
    Stopwatch = 'stopwatch',
    FaCircle1 = 'circle-1',
    Xmark = 'xmark',
    Robot = 'robot',
    MicrochipAi = 'microchip-ai',
    FileImage = 'file-image',
    Shield = 'shield',
    FileAudio = 'file-audio',
    FileVideo = 'file-video',
    FilePdf = 'file-pdf',
    FileSpreadsheet = 'file-spreadsheet',
    FileCode = 'file-code',
    FileCsv = 'file-csv',
    FileLines = 'file-lines',
    ChevronsLeft = 'chevrons-left',
    ChevronsRight = 'chevrons-right',
    XmarkLarge = 'xmark-large',
    Stream = 'bars-staggered',
    Envelope = 'envelope',
    AlarmSnooze = 'alarm-snooze',
    DiagramSubtask = 'diagram-subtask',
    Search = 'magnifying-glass',
    Spinner = 'spinner',
    Stop = 'stop',
    PhoneXmark = 'phone-xmark',
    Reply = 'reply',
    Share = 'share',
    PowerOff = 'power-off',
    AngleLeft = 'angle-left',
    LocationArrow = 'location-arrow',
    Expand = 'expand',
    CircleNodes = 'circle-nodes',
    Code = 'code',
    RectangleVerticalHistory = 'rectangle-vertical-history',
    Play = 'play',
    Comment = 'comment',
    CommentDots = 'comment-dots',
    CommentPlus = 'comment-plus',
    FileUpload = 'file-arrow-up',
    FaceSmile = 'face-smile',
    Edit = 'pen-to-square',
    Windows = 'windows',
    Linux = 'linux',
    Apple = 'apple',
    Google = 'google',
    GitHub = 'github',
    Facebook = 'facebook',
    Pause = 'pause',
    Times = 'times',
    Check = 'check',
    GooglePlay = 'google-play',
    Camera = 'camera',
    CameraSlash = 'camera-slash',
    MicrophoneSlash = 'microphone-slash',
    PhoneSlash = 'phone-slash',
    Desktop = 'desktop',
    DesktopSlash = 'desktop-slash',
    Droplet = 'droplet',
    DropletSlash = 'droplet-slash',
    Up = 'up',
    Left = 'left',
    Right = 'right',
    Undo = 'arrow-rotate-left',
    UserFriends = 'user-group',
    AnglesLeft = 'angles-left',
    Bell = 'bell',
    InfoCircle = 'circle-info',
    BellSlash = 'bell-slash',
    ArrowDownToLine = 'arrow-down-to-line',
    SquareTerminal = 'square-terminal',
    Minus = 'minus',
    VolumeSlash = 'volume-slash',
    VolumeUp = 'volume-high',
    Volume = 'volume',
    VolumeDown = 'volume-low',
    Redo = 'arrow-rotate-right',
    Paperclip = 'paperclip',
    ShareNodes = 'share-nodes',
    AnglesRight = 'angles-right',
    AddressBook = 'address-book',
    Book = 'book',
    Grip = 'grip',
    RotateReverse = 'rotate-reverse',
    Rotate = 'rotate',
    Crown = 'crown',
    LocationCrosshairs = 'location-crosshairs',
    Message = 'message',
    MessageLines = 'message-lines',
    LocationSmile = 'location-smile',
    LocationExclamation = 'location-exclamation',
    LocationPlus = 'location-plus',
    LocationXmark = 'location-xmark',
    LocationPin = 'location-pin-alt',
    MapPin = 'map-pin',
    CircleStar = 'circle-star',
    Heart = 'heart',
    CircleUser = 'circle-user',
    UserHelmetSafety = 'user-helmet-safety',
    ScrewdriverWrench = 'screwdriver-wrench',
    TrafficCone = 'traffic-cone',
    Car = 'car',
    Handshake = 'handshake',
    FileSignature = 'file-signature',
    HouseChimneyBlank = 'house-chimney-blank',
    Industry = 'industry',
    IndustryWindows = 'industry-windows',
    BuildingUser = 'building-user',
    CarBuilding = 'car-building',
    SquareH = 'square-h',
    ForkKnife = 'fork-knife',
    Building = 'building',
    BullseyeArrow = 'bullseye-arrow',
    Bullseye = 'bullseye',
    CrosshairsSimple = 'crosshairs-simple',
    FlagPennant = 'flag-pennant',
    Flag = 'flag',
    FlagSwallowtail = 'flag-swallowtail',
    Bookmark = 'bookmark',
    CircleBookmark = 'circle-bookmark',
    Sparkle = 'sparkle',
    HyprisRightsidebar = 'hypris-rightsidebar',
    HyprisMinimalize = 'hypris-minimalize',
    HyprisOverlay = 'hypris-overlay',
    HyprisItemCard = 'hypris-item-card',
    HyprisItemFullScreen = 'hypris-item-full-screen',
    CaretLeft = 'caret-left',
    CalendarLines = 'calendar-lines',
    Hourglass = 'hourglass',
    Dash = 'dash',
    Map = 'map',
    DiamondTurnRight = 'diamond-turn-right',
    Display = 'display',
    DisplaySlash = 'display-slash',
    Wifi = 'wifi',
    PhoneHangup = 'phone-hangup',
    Hyphen = 'hyphen',
    Rocket = 'rocket',
    Files = 'files',
    SquareQuestion = 'square-question',
    DrawPolygon = 'draw-polygon',
    PenRuler = 'pen-ruler',
    WindowRestore = 'window-restore',
    WindowMinimize = 'window-minimize',
    SquareMinus = 'square-minus',
    Circle = 'circle',
    ArrowRight = 'arrow-right',
    ArrowLeft = 'arrow-left',
    ExclamationCircle = 'exclamation-circle',
    Flask = 'flask',
    Sun = 'sun',
    Moon = 'moon',
    Cog = 'cog',
    Globe = 'globe',
    Home = 'home',
    Wrench = 'wrench',
    Marker = 'marker',
    BracketsCurly = 'brackets-curly',
    AngleDown = 'angle-down',
    QuoteLeft = 'quote-left',
    AngleDoubleRight = 'angle-double-right',
    Question = 'question',
    AnglesUp = 'angles-up',
    AnglesDown = 'angles-down',
    ExclamationTriangle = 'exclamation-triangle',
    CalendarPlus = 'calendar-plus',
    CalendarPen = 'calendar-pen',
    AngleRight = 'angle-right',
    Ghost = 'ghost',
    Snooze = 'snooze',
    SlidersV = 'sliders-v',
    FontCase = 'font-case',
    Image = 'image',
    TriangleExclamation = 'triangle-exclamation',
    Save = 'save',
    Palette = 'palette',
    AlignCenter = 'align-center',
    AlignRight = 'align-right',
    SortCircle = 'sort-circle',
    Qrcode = 'qrcode',
    Resize = 'up-right-and-down-left-from-center',
    SortUp = 'sort-up',
    SortDown = 'sort-down',
    TurnDownLeft = 'turn-down-left',
    FileChartPie = 'file-chart-pie',
    ChartLine = 'chart-line',
    ChartPie = 'chart-pie',
    ChartBar = 'chart-bar',
    FileContract = 'file-contract',
    FileInvoiceDollar = 'file-invoice-dollar',
    FileInvoice = 'file-invoice',
    Clipboard = 'clipboard',
    ClipboardList = 'clipboard-list',
    FileMedical = 'file-medical',
    FileCertificate = 'file-certificate',
    UserTie = 'user-tie',
    UserTieHairLong = 'user-tie-hair-long',
    UserNurse = 'user-nurse',
    UserDoctor = 'user-doctor',
    UserGear = 'user-gear',
    Users = 'users',
    HandshakeAngle = 'handshake-angle',
    Briefcase = 'briefcase',
    Suitcase = 'suitcase',
    PeopleGroup = 'people-group',
    Store = 'store',
    Shop = 'shop',
    Warehouse = 'warehouse',
    Hotel = 'hotel',
    Hospital = 'hospital',
    School = 'school',
    University = 'university',
    Church = 'church',
    StoreAlt = 'store-alt',
    Tree = 'tree',
    Leaf = 'leaf',
    Paw = 'paw',
    Truck = 'truck',
    Bus = 'bus',
    Taxi = 'taxi',
    Train = 'train',
    Subway = 'subway',
    Ship = 'ship',
    Plane = 'plane',
    Bicycle = 'bicycle',
    Motorcycle = 'motorcycle',
    GasPump = 'gas-pump',
    TruckMoving = 'truck-moving',
    TruckFast = 'truck-fast',
    ShippingFast = 'shipping-fast',
    Utensils = 'utensils',
    Burger = 'burger',
    Coffee = 'coffee',
    MartiniGlass = 'martini-glass',
    WineBottle = 'wine-bottle',
    BeerMugEmpty = 'beer-mug-empty',
    AppleWhole = 'apple-whole',
    Fish = 'fish',
    BreadSlice = 'bread-slice',
    CakeCandles = 'cake-candles',
    ShoppingCart = 'shopping-cart',
    BagShopping = 'bag-shopping',
    BasketShopping = 'basket-shopping',
    Box = 'box',
    BoxesStacked = 'boxes-stacked',
    BoxOpen = 'box-open',
    BoxArchive = 'box-archive',
    CashRegister = 'cash-register',
    Receipt = 'receipt',
    CreditCard = 'credit-card',
    MoneyBill = 'money-bill',
    Wallet = 'wallet',
    MoneyCheckDollar = 'money-check-dollar',
    PiggyBank = 'piggy-bank',
    ScaleBalanced = 'scale-balanced',
    CalendarCheck = 'calendar-check',
    Mobile = 'mobile',
    Laptop = 'laptop',
    Tablet = 'tablet',
    Comments = 'comments',
    AddressCard = 'address-card',
    Compass = 'compass',
    Medal = 'medal',
    Award = 'award',
    ShieldHalved = 'shield-halved',
    Lightbulb = 'lightbulb',
    Outlet = 'outlet',
    GlobeEurope = 'globe-europe',
    ArrowsRotate = 'arrows-rotate',
    ArrowPointer = 'arrow-pointer',
    HandBackFist = 'hand-back-fist',
    Hammer = 'hammer',
    NoteSticky = 'note-sticky',
    ObjectGroup = 'object-group',
    ObjectUngroup = 'object-ungroup',
    DiagramProject = 'diagram-project',
    DeleteLeft = 'delete-left',
    PenFancy = 'pen-fancy',
    Highlighter = 'highlighter',
    Eraser = 'eraser',
    Copyright = 'copyright',
    CircleQuestion = 'circle-question',
    Webhook = 'webhook',
    BracketsSquare = 'brackets-square',
    ListCheck = 'list-check',
    Pencil = 'Pencil',
    Cat = 'cat',
    Dog = 'dog',
    Horse = 'horse',
    Hippo = 'hippo',
    Otter = 'otter',
    Dragon = 'dragon',
    KiwiBird = 'kiwi-bird',
    Worm = 'worm',
    Locust = 'locust',
    Spider = 'spider',
    Bug = 'bug',
    Bugs = 'bugs',
    Dove = 'dove',
    Frog = 'frog',
    Crow = 'crow',
    Lizard = 'lizard',
    Snail = 'snail',
    Shrimp = 'shrimp',
    Mosquito = 'mosquito',
    BrandNodeJs = 'node-js',
    BrandGolang = 'golang',
    BrandPython = 'python',
    BrandPhp = 'php',
    BrandJava = 'java',
    BrandRust = 'rust',
    BrandSwift = 'swift',
    BrandMicrosoft = 'microsoft',
    BrandChrome = 'chrome',
    BrandDartLang = 'dart-lang',
    BrandPhoenixFramework = 'phoenix-framework',
    BrandAndroid = 'android',
    Gem = 'gem',
    ThumbsUp = 'thumbs-up',
    ThumbsDown = 'thumbs-down',
    CodeBranch = 'code-branch',
}

